export const ENTRY_DATA_CLINICAL_RESULTS = "Clinical Results";

export const ENTRY_DATA_CLINICAL_RESULTS_KEYS = {
  resultsClassification: "Results Classification",
} as const;
